import * as XLSX from 'xlsx-js-style';

export function exportTutkimustarpeetToExcel({
  tableData,
  totals,
  years,
  filename
}) {
  const currentYear = new Date().getFullYear();
  const colCount = 1 + years.length; // label + years

  const GREEN = '04AA00';
  const WHITE = 'FFFFFF';
  const BORDER = 'DDDDDD';

  const rows = [];
  const itemRowMeta = [];

  const normalizeValue = (v) => {
    if (v === '' || v === null || v === undefined || v === '0' || v === 0) {
      return '';
    }
    const n = Number(v);
    return Number.isNaN(n) ? '' : n;
  };

  // Super header
  rows.push([
    `Kustannusarvio (x 1000€) Kustannustaso ${currentYear} sis. Alv 25,5%`,
    ...Array(colCount - 1).fill('')
  ]);

  // Header row
  rows.push([
    'Tutkimustarpeet',
    ...years.map(String)
  ]);

  // Body rows
  (tableData || []).forEach((section) => {
    (section.items || []).forEach((item) => {
      const label = (item.label || '').trim();
      if (label.length < 1) return;

      const values = (item.values || []).map(normalizeValue);
      const rowIndex = rows.length;

      itemRowMeta.push({
        rowIndex,
        values
      });

      rows.push([
        label,
        ...values
      ]);
    });
  });

  // Totals row
  const totalRowIdx = rows.length;
  rows.push([
    'YHTEENSÄ',
    ...(totals || []).map(normalizeValue)
  ]);

  const ws = XLSX.utils.aoa_to_sheet(rows);

  // Merge super header across whole row
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } }
  ];

  ws['!cols'] = [
    { wch: 42 },
    ...years.map(() => ({ wch: 9 }))
  ];

  ws['!rows'] = rows.map((_, i) => {
    if (i === 0 || i === 1) return { hpt: 20 };
    return { hpt: 18 };
  });

  const baseBorder = {
    top: { style: 'thin', color: { rgb: BORDER } },
    bottom: { style: 'thin', color: { rgb: BORDER } },
    left: { style: 'thin', color: { rgb: BORDER } },
    right: { style: 'thin', color: { rgb: BORDER } }
  };

  const headerStyle = {
    font: { bold: true, color: { rgb: WHITE } },
    fill: { fgColor: { rgb: GREEN } },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: baseBorder
  };

  const superHeaderStyle = {
    font: { bold: true, color: { rgb: WHITE } },
    fill: { fgColor: { rgb: GREEN } },
    alignment: { horizontal: 'right', vertical: 'center', wrapText: false },
    border: baseBorder
  };

  const labelStyle = {
    alignment: { horizontal: 'left', vertical: 'center', wrapText: true },
    border: baseBorder
  };

  const numberStyle = {
    alignment: { horizontal: 'center', vertical: 'center' },
    numFmt: '0',
    border: baseBorder
  };

  const positiveValueStyle = {
    font: { bold: true, color: { rgb: WHITE } },
    fill: { fgColor: { rgb: GREEN } },
    alignment: { horizontal: 'center', vertical: 'center' },
    numFmt: '0',
    border: baseBorder
  };

  const totalsStyle = {
    font: { bold: true, color: { rgb: WHITE } },
    fill: { fgColor: { rgb: GREEN } },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: baseBorder
  };

  // Row 0
  for (let c = 0; c < colCount; c++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    if (!ws[addr]) continue;
    ws[addr].s = superHeaderStyle;
  }

  // Row 1
  for (let c = 0; c < colCount; c++) {
    const addr = XLSX.utils.encode_cell({ r: 1, c });
    if (!ws[addr]) continue;
    ws[addr].s = headerStyle;
  }

  // Body
  itemRowMeta.forEach(({ rowIndex, values }) => {
    const labelAddr = XLSX.utils.encode_cell({ r: rowIndex, c: 0 });
    if (ws[labelAddr]) ws[labelAddr].s = labelStyle;

    values.forEach((v, idx) => {
      const c = idx + 1;
      const addr = XLSX.utils.encode_cell({ r: rowIndex, c });
      if (!ws[addr]) return;

      ws[addr].s =
        v !== '' && Number(v) > 0
          ? positiveValueStyle
          : numberStyle;
    });
  });

  // Totals
  for (let c = 0; c < colCount; c++) {
    const addr = XLSX.utils.encode_cell({ r: totalRowIdx, c });
    if (ws[addr]) ws[addr].s = totalsStyle;
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Tutkimustarpeet');

  const outFilename = filename || `PTS_Tutkimustarpeet_${currentYear}.xlsx`;
  XLSX.writeFile(wb, outFilename);
}